<template>
    <div class="content">
        <div class="container-fluid" v-if="report">
            <div class="row">
                <div class="col-md-12">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span></h5>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': waiting }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'period'">Period</span>
                                        <span v-else-if="column === 'my_feed'">My Feed, $</span>
                                        <span v-else-if="column === 'muse'">Muse, $</span>
                                        <span v-else-if="column === 'wallpapers'">Wallpapers, $</span>
                                        <span v-else-if="column === 'imagine'">Imagine, $</span>
                                        <span v-else-if="column === 'framy'">Framy, $</span>
                                        <span v-else-if="column === 'marketing_spend'">Spend (Marketing, other), $</span>
                                        <span v-else-if="column === 'summary'">Summary, $</span>
                                        <span v-else> </span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{{ report.date_start }} - {{ report.date_end }}</td>
                                    <td>{{  Intl.NumberFormat().format(report.info[0]) }}</td>
                                    <td>{{  Intl.NumberFormat().format(report.info[1]) }}</td>
                                    <td>{{  Intl.NumberFormat().format(report.info[2]) }}</td>
                                    <td>{{  Intl.NumberFormat().format(report.info[3]) }}</td>
                                    <td>{{  Intl.NumberFormat().format(report.info[4]) }}</td>
                                    <td>{{  Intl.NumberFormat().format(report.marketing_spend) }} ({{  Intl.NumberFormat().format(report.other_spend) }})</td>
                                    <td>{{  Intl.NumberFormat().format(report.summary) }}</td>
                                    <td><a class="text-primary" @click="save()">Сохранить</a></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    name: 'EditAlbum',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            columns: ['period', 'my_feed', 'muse', 'wallpapers', 'imagine', 'framy', 'marketing_spend', 'summary', ''],
            token: localStorage.getItem('token'),
            waiting: false,
            report: null,
            albums: [],
        }
    },
    created: function () {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function () {
            window.history.back();
        },
        get: function (id) {
            let self = this;
            this.waiting = true;

            axios.get(
                `${this.$hostname}/admin/reports/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.report = JSON.parse(JSON.stringify(response.data));

                    self.waiting = false;
                })
                .catch(function (error) {

                    self.waiting = false;

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        save: function () {
            let self = this;

            let track = JSON.parse(JSON.stringify(this.track));

            self.waiting = true;

            axios.post(
                `${this.$hostname}/admin/tracks/${this.id}/update`,
                track,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    const notification = {
                        template: `<span><b>Трек был успешно обновлен</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        })

                    self.waiting = false;

                  //  self.$router.push('/tracks');
                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    self.waiting = false;
                });
        },
        uploadFile: function (event, type) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            let needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type,
                        needID3: needID3
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {

                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    data.duration = Math.floor(data.duration)

                    let minutes = (Math.floor(data.duration / 60)).toString();
                    let seconds = (data.duration % 60) < 10 ? '0' + (data.duration % 60).toString() : (data.duration % 60).toString();
                    self.track.duration = minutes + ':' + seconds;
                }

            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },

    }
}

</script>
<style scoped>
.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}
.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}
.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}
.btn-file {
    display: none;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.device1 {
    display: inline-block;
    /*width: 281px;*/
    /*height: 609px;*/
    width: 337px;
    height: 731px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 40px;
}

.device2 {
    display: inline-block;
    /*width: 310px;*/
    /*height: 552px;*/
    width: 372px;
    height: 662px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.device3 {
    display: inline-block;
    /*width: 384px;*/
    /*height: 640px;*/
    width: 461px;
    height: 614px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.mt30 {
    margin-top: 30px;
}

#ajaxForm, #ajaxForm2 {
    position: relative;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Edit.vue